/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Occupation } from "./modelOccupation";

class ControllerOccupation extends ControllerModel {
  constructor() {
    super("ControllerOccupation");
    
    this.setNewNode = (callback) => {
      let occupation = new Occupation();
      occupation.decorate(callback);
      this.addNode(occupation);
      SingletonFlowchart.SaveStatus();
    }

    this.loadNode = (node, callback) => {
      let occupation = new Occupation();
      occupation.copyFrom(node);
      occupation.decorate(callback);
      this.addNode(occupation);
    }

    this.getProperties = async (node) => {
      let n = new Occupation();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Occupation();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerOccupation };
